import { render, staticRenderFns } from "./SmsComposer.vue?vue&type=template&id=114740d2"
import script from "./SmsComposer.vue?vue&type=script&lang=js"
export * from "./SmsComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports